/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
_affirm_config = {
    public_api_key: "PFDA8LZM1F2SPSID",
    script: "https://cdn1.affirm.com/js/v2/affirm.js"
};
(function(l, g, m, e, a, f, b) {
    var d, c = l[m] || {},
        h = document.createElement(f),
        n = document.getElementsByTagName(f)[0],
        k = function(a, b, c) {
            return function() {
                a[b]._.push([c, arguments])
            }
        };
    c[e] = k(c, e, "set");
    d = c[e];
    c[a] = {};
    c[a]._ = [];
    d._ = [];
    c[a][b] = k(c, a, b);
    a = 0;
    for (b = "set add save post open empty reset on off trigger ready setProduct".split(" "); a < b.length; a++) d[b[a]] = k(c, e, b[a]);
    a = 0;
    for (b = ["get", "token", "url", "items"]; a < b.length; a++) d[b[a]] = function() {};
    h.async = !0;
    h.src = g[f];
    n.parentNode.insertBefore(h, n);
    delete g[f];
    d(g);
    l[m] = c
})(window, _affirm_config, "affirm", "checkout", "ui", "script", "ready");

var _katapult_config = {
    api_key: "62dcac6e98942406e023637607f258027e9a2f40",
    environment: "https://www.katapult.com"
};
! function(e, t) {
    e.katapult = e.katapult || {};
    var n, i, r;
    i = !1, n = document.createElement("script"), n.type = "text/javascript", n.async = !0, n.src = t.environment + "/" + "plugin/js/katapult.js", n.onload = n.onreadystatechange = function() {
        i || this.readyState && "complete" != this.readyState || (i = !0, e.katapult.setConfig(t.api_key))
    }, r = document.getElementsByTagName("script")[0], r.parentNode.insertBefore(n, r);
    var s = document.createElement("link");
    s.setAttribute("rel", "stylesheet"), s.setAttribute("type", "text/css"), s.setAttribute("href", t.environment + "/" + "plugin/css/katapult.css");
    var a = document.querySelector("head");
    a.insertBefore(s, a.firstChild)
}(window, _katapult_config);

// $('.katapult-preapprove').on('click', function() {
//     katapult.preapprove();
// });

// jQuery(document).ready(function($) {
//     $(window).on('popstate', function() {
//         if (window.location.hash != '#smile-home') {
//             if (window.theme.pageType === 'collection') {
//                 location.reload(true);
//             }
//         }
//     });
// });